import { FooterInfoContainer, MarketPlaceLinksList, MarketPlaceListItem, MarketPlaceLinkItem, AISolutionsBadge } from './styles';
import { useTranslatedObject } from '../../utils/translation';
import { FooterNavigationBar, sendGA4Data } from '../../analytics/events';
import { CONFIG } from '../../utils/config';
import { buildLegacyLoginContinueUrl } from '../../utils/helper';

const Marketplace = ({ navigate }) => {
  const footer = useTranslatedObject('footer');

  const handleLinkClick = (e, item, url) => {
    e.stopPropagation();
    const isAbsolute = /^https?:\/\//i.test(url);
    const targetUrl = buildLegacyLoginContinueUrl(url);
    if (isAbsolute || item.openInNewTab) {
      const target = item.openInNewTab ? '_blank' : '_self';
      if (target === '_self') {
        navigate?.(targetUrl);
      } else {
        e.preventDefault();
        window.open(targetUrl, target);
      }
    } else {
      navigate?.(targetUrl);
    } 
    sendGA4Data(FooterNavigationBar, { eventCategory: 'ADP Marketplace', eventLabel: item.label });
  };

  return (
    <FooterInfoContainer id="marketplace-container">
      <MarketPlaceLinksList id="marketplace-list">
        {footer?.adp_marketplace_links?.map((item, index) => {
          const getMarketplaceUrl = (item) => {
            return !item.openInNewTab ? item.url : CONFIG.LEGACY_APP_URL + item.url;
          };
          const url = getMarketplaceUrl(item);
          return (
            <MarketPlaceListItem
              id={`marketplace-list-item-${index}`}
              key={index}
            >
              <MarketPlaceLinkItem
                aria-label={item.label}
                id={`marketplace-link-item-${item.label}`}
                href={url}
                onClick={(e) => handleLinkClick(e, item, url)}
              >
                {item.isNew ? (
                  <span>
                    {item.label}
                    <AISolutionsBadge>New!</AISolutionsBadge>
                  </span>
                ) : (
                  item.label
                )}
              </MarketPlaceLinkItem>
            </MarketPlaceListItem>
          );
        })}
      </MarketPlaceLinksList>
    </FooterInfoContainer>
  );
};

export default Marketplace;